export default __webpack_public_path__ + "static/media/FZ.eaaf5506.png";